import React from 'react'
import PropTypes from 'prop-types'
import { TableContext } from './context'

const TableControllerComponent = ({ contextController, children }) => (
  <TableContext.Provider value={contextController}>
    {children}
  </TableContext.Provider>
)

TableControllerComponent.propTypes = {
  contextController: PropTypes.shape().isRequired,
  children: PropTypes.node,
}

export default TableControllerComponent
